import { Component, OnInit, Input } from '@angular/core';
import { AnimalData, Entries } from './animal-rarities-classes';

@Component({
  selector: 'app-animal-rarities',
  templateUrl: './animal-rarities.component.html',
  styleUrls: ['./animal-rarities.component.css']
})
export class AnimalRaritiesComponent implements OnInit {

  // metadata for the entries.
  @Input() animalEntries: Entries;

  animalData = AnimalData; // pull from the global export

  constructor() { }

  ngOnInit() {
  }

}
